import { useMemo } from "react";

import moment from "moment";
import { useLocation } from "react-router-dom";

import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";

import { hashTimeFrame } from "../components/Chart/settings";

const isDateRangeValid = (from?: string | null, to?: string | null) => {
  const momentFrom = moment.unix(Number(from));
  const momentTo = moment.unix(Number(to));

  if (!momentFrom.isValid() || !momentTo.isValid())
    return { valid: false, range: null };

  if (momentFrom.isBefore(momentTo) && momentTo.isSameOrBefore(moment()))
    return {
      valid: true,
      range: { from: momentFrom.toDate(), to: momentTo.toDate() }
    };

  return { valid: false, range: null };
};

const useInitialTimeframe = (
  initTimeFrame: TimeFrameType = { id: "15m" }
): TimeFrameType => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const [from, to, poll, range] = [
    params.get("from"),
    params.get("to"),
    params.get("poll"),
    params.get("range")
  ];

  const initialTimeframe = useMemo(
    () => {
      if (["15m", "1h", "8h", "24h"].includes(range?.toLowerCase() || "")) {
        return hashTimeFrame({ id: range?.toLowerCase(), poll });
      }
      const dateRange = isDateRangeValid(from, to);
      const r = dateRange.range;
      return r && dateRange.valid
        ? hashTimeFrame(r)
        : hashTimeFrame(initTimeFrame);
      // This is a oneside update, needless to include deps to avoid double
      // or possible infinite loop if any of the paramns changes
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return initialTimeframe;
};

export default useInitialTimeframe;
